import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getFormattedDate } from "../../functions/time";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import {
  setDatePicker,
  setFromDate,
  setToDate,
} from "../../redux/features/dataSlice";
import { toast } from "react-toastify";
import ButtonPrimary from "../button/ButtonPrimary";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const Datepicker = () => {
  const { fromDate, toDate } = useSelector((state) => state.data);
  console.log(fromDate, toDate);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();

  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const { search } = useSelector((state) => state.data);

  const dynamicYearOptions = () => {
    const years = [];
    for (let year = 1990; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };

  const [yearOptions, setYearOptions] = useState(dynamicYearOptions());

  const handleSearch = () => {
    if (toDate && fromDate && toDate > fromDate) {
      const encodedQuery = encodeURIComponent(search);
      if (!search) {
        navigate("/");
      } else if (location.pathname.startsWith("/category")) {
        const url =
          `${location.pathname}?filter=Custom%20Date&range=` +
          getFormattedDate(fromDate) +
          " - " +
          getFormattedDate(toDate);
        navigate(url);
      } else {
        navigate(
          `/search/${encodedQuery}?filter=Custom%20Date&range=` +
            getFormattedDate(fromDate) +
            " - " +
            getFormattedDate(toDate)
        );
      }

      dispatch(setDatePicker(false));
    } else {
      toast.error("Please select valid dates.");
    }
  };

  const CustomHeader = ({
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    return (
      <div className="datepicker-header">
        <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
          {"<"}
        </button>
        <div>
          <select
            value={date.getFullYear()}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {yearOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[date.getMonth()]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
          {">"}
        </button>
      </div>
    );
  };

  useEffect(() => {
    if (fromDate && toDate) {
      if (fromDate >= toDate) {
        toast.error("Start date must be earlier than end date.");
      }
    }
  }, [fromDate, toDate]);

  return (
    <>
      <div className="bg-dark-datepicker"></div>
      <div className="container-datepicker">
        <CloseIcon
          className="close-icon"
          onClick={() => dispatch(setDatePicker(false))}
        />
        <div className="custom-datepicker flex-gap">
          <div className="content-datepicker">
            <p className="title">
              Start Date: {fromDate && getFormattedDate(fromDate)}
            </p>
            <DatePicker
              wrapperClassName="datepicker"
              selected={fromDate}
              renderCustomHeader={(props) => <CustomHeader {...props} />}
              onChange={(date) => dispatch(setFromDate(date))}
              inline
              maxDate={new Date()}
            />
          </div>
          <div className="content-datepicker">
            <p className="title">
              End Date: {toDate && getFormattedDate(toDate)}
            </p>
            <DatePicker
              wrapperClassName="datepicker"
              selected={toDate}
              renderCustomHeader={(props) => <CustomHeader {...props} />}
              onChange={(date) => dispatch(setToDate(date))}
              inline
              maxDate={new Date()}
            />
          </div>
        </div>
        <div className="search-container">
          <ButtonPrimary
            className="search-btn"
            text="search"
            onClick={handleSearch}
          />
        </div>
      </div>
    </>
  );
};

export default Datepicker;
